import Button from "@components/Button"
import Confetti from "@components/Confetti"
import Layout from "@components/Layout"
import { useRef } from "react"
import { Trans, useTranslation } from "react-i18next"
import { Form } from "react-router-dom"

export default function FeedbackPage() {
  const { t } = useTranslation()
  const formRef = useRef<HTMLFormElement>(null)

  const submitForm = () => {
    if (formRef.current) {
      formRef.current.requestSubmit()
    }
  }

  return (
    <>
      <Confetti onFinish={submitForm} />

      <Layout>
        <div className="flex grow flex-col justify-center gap-8 text-center">
          <span className="text-center text-7xl">🎊</span>

          <p className="text-center text-2xl font-bold">
            <Trans
              i18nKey="pages.onboarding.feedback.text"
              components={{
                br: <br />,
              }}
            />
          </p>
        </div>

        <Form className="shrink-0 text-center" method="post" ref={formRef}>
          <Button iconOnly title={t("shared.continue")} type="submit" />
        </Form>
      </Layout>
    </>
  )
}
